import axios from 'axios';

export default (function (_ref, inject) {
    var app = _ref.app,
        redirect = _ref.redirect;

    app.router.beforeEach(function (to, from, next) {
        axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/activity-log', {
            //headers: {'X-Cookie': document.cookie},
            params: {
                page_url: to.fullPath
            }
        });
        next();
    });
});


//////////////////
// WEBPACK FOOTER
// ./plugins/activity-logger.js
// module id = ./plugins/activity-logger.js
// module chunks = 54